import { render, staticRenderFns } from "./BasicHealthSurvey.vue?vue&type=template&id=16ee85fa&scoped=true&"
import script from "./BasicHealthSurvey.vue?vue&type=script&lang=js&"
export * from "./BasicHealthSurvey.vue?vue&type=script&lang=js&"
import style0 from "./BasicHealthSurvey.vue?vue&type=style&index=0&id=16ee85fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ee85fa",
  null
  
)

export default component.exports